import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/* eslint-disable jsx-a11y/alt-text */
import { memo } from 'react';
import cc from 'classcat';
import PropTypes from 'prop-types';
import css from './Dress.module.scss';
import dress from './Dress3.module.scss';
import Quote from './Quote';
import Dress from './Dress';
import Image from './Image';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var Dress3 = function Dress3(_ref) {
  var copy = _ref.copy,
      images = _ref.images,
      isMobile = _ref.isMobile,
      name = _ref.name,
      quotes = _ref.quotes,
      url = _ref.url,
      video = _ref.video;
  return /*#__PURE__*/_jsxs(Dress, {
    copy: copy,
    isMobile: isMobile,
    name: name,
    url: url,
    video: video,
    children: [/*#__PURE__*/_jsx("div", {
      className: cc([css.quote, dress.quote1]),
      "data-dress-image": "true",
      children: /*#__PURE__*/_jsx(Quote, _objectSpread({}, quotes[0]))
    }), /*#__PURE__*/_jsx(Image, _objectSpread(_objectSpread({}, images[1]), {}, {
      cls: dress.image2,
      name: name,
      sizes: [202, 437]
    })), /*#__PURE__*/_jsx(Image, _objectSpread(_objectSpread({}, images[0]), {}, {
      cls: dress.image1,
      name: name,
      sizes: [162, 350]
    })), /*#__PURE__*/_jsx(Image, _objectSpread(_objectSpread({}, images[2]), {}, {
      cls: dress.image3,
      name: name,
      sizes: [169, 273]
    })), /*#__PURE__*/_jsx(Image, _objectSpread(_objectSpread({}, images[3]), {}, {
      cls: dress.image4,
      name: name,
      sizes: [169, 273]
    })), /*#__PURE__*/_jsx(Image, _objectSpread(_objectSpread({}, images[5]), {}, {
      cls: dress.image6,
      name: name,
      sizes: [264, 648]
    })), /*#__PURE__*/_jsx(Image, _objectSpread(_objectSpread({}, images[4]), {}, {
      cls: dress.image5,
      name: name,
      sizes: [102, 250]
    })), /*#__PURE__*/_jsx("div", {
      className: cc([css.quote, dress.quote2]),
      "data-dress-image": "true",
      children: /*#__PURE__*/_jsx(Quote, _objectSpread({}, quotes[1]))
    })]
  });
};

Dress3.propTypes = {
  copy: PropTypes.string.isRequired,
  images: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  isMobile: PropTypes.bool.isRequired,
  name: PropTypes.string.isRequired,
  quotes: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  url: PropTypes.string.isRequired,
  video: PropTypes.shape({}).isRequired
};
export default /*#__PURE__*/memo(Dress3);